const ks = (data, Vue) => {
  let list = Vue => {
    let arr = [
      {
        title: '期数',
        align: 'center',
        key: 'issue_id',
        width: 170
      },
      {
        title: '开奖号码',
        align: 'center',
        width: 170,

        render: (h, { row }) => {
          return (
            <div class="ball num">
              {row.ballList.map((x, i) => {
                return <span>{x}</span>;
              })}
            </div>
          );
        }
      }
    ];
    var a = ['一', '二', '三', '四', '五', '六', '七', '八', '九'];
    for (let i = 0; i < data[0].ballList.length; i++) {
      let obj = {};
      let e = a[i];
      obj.title = `第${e}球`;
      obj.align = 'center';
      obj.key = 'resultStr';
      obj.className = `table_info_column_${i}`;
      obj.children = treeChildren(i, data, Vue);
      arr.push(obj);
    }
    return arr;
  };
  let lostList = Vue => {
    let arr = [
      {
        title: '数据统计',
        align: 'center',
        key: 'name',
        className: `table_issueId`,
        width: 340
      }
    ];
    var a = ['一', '二', '三', '四', '五', '六', '七', '八', '九'];
    for (let i = 0; i < 3; i++) {
      let obj = {};
      let e = a[i];
      obj.title = `第${e}球`;
      obj.align = 'center';
      obj.className = `table_info_column_${i}`;
      obj.children = lostChildren(data, i);
      arr.push(obj);
    }
    return arr;
  };
  return { list, lostList };
};
let treeChildren = (index, data, Vue) => {
  var arr = [];
  if (data) {
    for (let i = 1; i < 7; i++) {
      var obj = {};
      obj.title = `${i}`;
      obj.align = 'center';
      // obj.width = '34';
      obj.className = `tree_table_children_${index}`;
      obj.render = (h, row) => {
        var name = `ball${index + 1}`;
        if (row.row.ball_json[name].nums[i] == 0) {
          return <span class="red">{data[row.index].ballList[index]}</span>;
        } else {
          if (Vue.divideList[name].nums[i] > row.index) {
            return <span class="divide_lost_info lost_info">{row.row.ball_json[name].nums[i]}</span>;
          } else {
            return <span class="lost_info">{row.row.ball_json[name].nums[i]}</span>;
          }
          // return <span class="lost_info">{row.row.ball_json[name].nums[i]}</span>;
        }
      };
      arr.push(obj);
    }
    return arr;
  }
};
let lostChildren = (data, index) => {
  var arr = [];
  for (let i = 1; i < 7; i++) {
    var obj = {};
    obj.title = `${i}`;
    obj.align = 'center';
    // obj.width = '34';
    obj.className = `lost_table_children_${i}`;
    obj.render = (h, row) => {
      var name = `ball${index + 1}`;
      var key = row.row.key;
      var n = row.row.lost[name].nums[i];
      // console.log(n[key], n, 'asdfasdf');
      if (key != 'averageOmit') {
        return <span>{n[key] ? n[key] : 0}</span>;
      }
    };
    arr.push(obj);
  }
  return arr;
};

export default ks;



// WEBPACK FOOTER //
// ./src/pages/Trend/Jibenzoushi/columns/ks.js